import React from "react";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Hero Section */}
      <div className="bg-black text-white">
        <div className="max-w-6xl mx-auto px-4 py-24">
          <div className="max-w-3xl">
            <p className="text-red-500 font-medium mb-4 tracking-wide">FREELANCE PROJECT</p>
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight text-white">
              IT Shop
              <span className="block text-gray-400">E-Commerce Platform</span>
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              ระบบ E-Commerce สำหรับจำหน่ายอุปกรณ์ไอที พัฒนาด้วย React.js และ Spring Boot
              ผลงานต้นแบบที่พัฒนาให้ลูกค้า โดยแปลงข้อมูลเป็น Demo สำหรับแสดงผลงาน
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-4 py-16">

        {/* About Project */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 mb-20">
          <div className="lg:col-span-3">
            <div className="bg-white rounded-2xl p-8 h-full">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">เกี่ยวกับโปรเจค</h2>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong className="text-gray-900">IT Shop</strong> เป็นผลงานต้นแบบ (Prototype)
                  ที่พัฒนาขึ้นเป็นงาน Freelance สำหรับลูกค้า
                  เพื่อใช้เป็นโครงสร้างเริ่มต้นในการพัฒนาต่อยอด
                </p>
                <p>
                  ระบบครอบคลุม <span className="text-red-600 font-semibold">3 บทบาท</span> ได้แก่
                  ผู้ซื้อ (User), ผู้ขาย (Seller) และ ผู้ดูแลระบบ (Admin)
                  โดยแต่ละบทบาทมีสิทธิ์และหน้าที่แตกต่างกัน
                </p>
                <p>
                  ข้อมูลในระบบนี้เป็นข้อมูลจำลอง (Demo Data)
                  ที่แปลงมาเพื่อแสดงการทำงานของระบบ
                </p>
              </div>
            </div>
          </div>
          <div className="lg:col-span-2 space-y-4">
            <div className="bg-red-600 rounded-2xl p-6 text-white">
              <p className="text-sm font-medium text-white/70 mb-1">ประเภท</p>
              <p className="text-xl font-bold">Freelance Project</p>
            </div>
            <div className="bg-gray-900 rounded-2xl p-6 text-white">
              <p className="text-sm font-medium text-white/60 mb-1">สถานะ</p>
              <p className="text-xl font-bold text-yellow-400">Prototype / Demo</p>
            </div>
            <div className="bg-white rounded-2xl p-6">
              <p className="text-sm font-medium text-gray-500 mb-1">ลักษณะงาน</p>
              <p className="text-lg font-bold text-gray-700">ผลงานต้นแบบสำหรับลูกค้า</p>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">ฟีเจอร์หลัก</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl p-8 border-l-4 border-red-500">
              <h3 className="text-xl font-bold text-gray-900 mb-3">User Management</h3>
              <p className="text-gray-600">
                ระบบสมาชิกพร้อม JWT Authentication,
                แบ่งสิทธิ์ตาม Role (Admin, Seller, User)
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 border-l-4 border-blue-500">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Shopping System</h3>
              <p className="text-gray-600">
                ตะกร้าสินค้า, Checkout, ประวัติการสั่งซื้อ,
                ระบบสถานะการจัดส่ง
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 border-l-4 border-green-500">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Seller Dashboard</h3>
              <p className="text-gray-600">
                จัดการสินค้า, ดูคำสั่งซื้อ, อัปเดตสถานะจัดส่ง,
                สถิติการขาย
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 border-l-4 border-purple-500">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Admin Panel</h3>
              <p className="text-gray-600">
                จัดการผู้ใช้, อนุมัติผู้ขาย, ระงับบัญชี,
                จัดการสินค้าทั้งระบบ
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 border-l-4 border-yellow-500">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Product Features</h3>
              <p className="text-gray-600">
                หมวดหมู่สินค้า, รูปภาพหลายรูป, รีวิวและให้คะแนน,
                รายการถูกใจ
              </p>
            </div>
            <div className="bg-white rounded-2xl p-8 border-l-4 border-pink-500">
              <h3 className="text-xl font-bold text-gray-900 mb-3">Responsive Design</h3>
              <p className="text-gray-600">
                รองรับทุกขนาดหน้าจอ, Modern UI/UX,
                ใช้งานง่าย
              </p>
            </div>
          </div>
        </div>

        {/* Tech Stack */}
        <div className="bg-white rounded-2xl p-8 mb-20">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Tech Stack</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div className="w-16 h-16 bg-cyan-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">⚛️</span>
              </div>
              <p className="font-bold text-gray-900">React.js</p>
              <p className="text-sm text-gray-500">Frontend</p>
            </div>
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🍃</span>
              </div>
              <p className="font-bold text-gray-900">Spring Boot</p>
              <p className="text-sm text-gray-500">Backend</p>
            </div>
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🗄️</span>
              </div>
              <p className="font-bold text-gray-900">MySQL</p>
              <p className="text-sm text-gray-500">Database</p>
            </div>
            <div className="text-center p-6 bg-gray-50 rounded-xl">
              <div className="w-16 h-16 bg-sky-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">🎨</span>
              </div>
              <p className="font-bold text-gray-900">Tailwind CSS</p>
              <p className="text-sm text-gray-500">Styling</p>
            </div>
          </div>
        </div>

        {/* Developer Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          <div className="lg:col-span-2 bg-gradient-to-br from-gray-900 to-black rounded-2xl p-10 text-white">
            <p className="text-gray-400 text-sm mb-4">Developer</p>
            <h3 className="text-4xl font-bold mb-2 text-white">Wintapas</h3>
            <p className="text-red-400 font-medium mb-6">Backend Developer</p>
            <p className="text-gray-300 leading-relaxed mb-6">
              นักพัฒนาที่ถนัดด้าน Backend Development
              ที่สามารถพัฒนา Frontend ได้ พร้อมเรียนรู้เทคโนโลยีใหม่ๆ
            </p>
            <div className="flex gap-3 flex-wrap">
              <span className="px-4 py-2 bg-white/10 rounded-lg text-sm">React</span>
              <span className="px-4 py-2 bg-white/10 rounded-lg text-sm">Spring Boot</span>
              <span className="px-4 py-2 bg-white/10 rounded-lg text-sm">MySQL</span>
              <span className="px-4 py-2 bg-white/10 rounded-lg text-sm">REST API</span>
              <span className="px-4 py-2 bg-white/10 rounded-lg text-sm">JWT</span>
            </div>
          </div>
          <div className="flex flex-col justify-center">
            <Link
              to="/all-products"
              className="w-full py-4 px-8 bg-red-600 text-white rounded-xl font-semibold text-center hover:bg-red-700 transition-all mb-4"
            >
              ดูสินค้าทั้งหมด
            </Link>
            <Link
              to="/home"
              className="w-full py-4 px-8 bg-white text-gray-900 rounded-xl font-semibold text-center hover:bg-gray-50 transition-all border border-gray-200"
            >
              กลับหน้าแรก
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default About;
